<script>
    import { createEventDispatcher } from 'svelte';

    export let matchedPlans = [];
    export let selectedPlanKey = null;
    export let currencies = {};
    export let couponApplies = false;
    export let discountAmount = 0;
    export let currentCoupon = null;
    export let calculateDiscountedPrice = (amount) => amount;

    const dispatch = createEventDispatcher();

    function symbol(code) {
        return currencies[code] || '$';
    }

    function select(key) {
        dispatch('select', key);
    }
</script>

<div class="text-left">
    <span class="text-gray-800 font-medium">Select Your Plan</span>
    <p class="text-xs text-gray-500 mt-1">Choose the monitoring plan that best fits your journey. All plans include full app access and data monitoring.</p>
</div>
<div class="grid grid-cols-1 gap-3" style="grid-template-columns: repeat({matchedPlans.length}, minmax(0, 1fr));">
    {#each matchedPlans as plan}
    <button
        type="button"
        class="relative rounded-xl border-2 p-4 text-left transition-all cursor-pointer
            {selectedPlanKey === plan.key ? 'border-[var(--secondary-color)] bg-red-50/30' : 'border-gray-200 hover:border-gray-300'}"
        style={selectedPlanKey === plan.key ? `border-color: var(--secondary-color); background-color: color-mix(in srgb, var(--secondary-color) 6%, white)` : ''}
        on:click={() => select(plan.key)}
    >
        {#if plan.badge_style}
        <span class="absolute -top-3 left-1/2 -translate-x-1/2 text-xs font-bold uppercase tracking-wide px-2 py-0.5 rounded-full whitespace-nowrap
            {plan.badge_style === 'popular' ? 'bg-green-700 text-white' : 'bg-gray-900 text-white'}">
            {plan.badge_style === 'popular' ? 'MOST POPULAR' : 'BEST VALUE'}
        </span>
        {/if}
        <div class="flex items-center justify-between">
            <span class="font-semibold text-gray-800">{plan.label}</span>
            <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center
                {selectedPlanKey === plan.key ? 'border-[var(--secondary-color)]' : 'border-gray-300'}">
                {#if selectedPlanKey === plan.key}
                <div class="w-3 h-3 rounded-full bg-[var(--secondary-color)]"></div>
                {/if}
            </div>
        </div>
        <div class="mt-2">
            {#if plan.rawAmount != null}
                {#if couponApplies && discountAmount > 0}
                <span class="text-2xl font-bold text-gray-900">{symbol(plan.currency)}{calculateDiscountedPrice(plan.rawAmount, currentCoupon).toFixed(2)}</span>
                <span class="text-sm text-gray-500 line-through ml-1">{symbol(plan.currency)}{plan.rawAmount.toFixed(2)}</span>
                {:else}
                <span class="text-2xl font-bold text-gray-900">{symbol(plan.currency)}{plan.rawAmount.toFixed(2)}</span>
                {/if}
                {#if plan.interval_count > 1}
                <p class="text-xs text-gray-500 mt-0.5">{symbol(plan.currency)}{plan.monthlyPrice.toFixed(2)}/mo</p>
                {/if}
            {/if}
        </div>
        {#if plan.sublabel}
        <p class="text-xs text-gray-500 mt-1">{plan.sublabel}</p>
        {/if}
    </button>
    {/each}
</div>
